import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';
import { createElement as panoramaSiteCreateElement, useEffect as panoramaSiteUseEffect, useState as panoramaSiteUseState } from 'react';
import { useAuthenticatedUser as panoramaSiteUseUser, useSiteConfig as panoramaSiteUseConfig, getAuthenticatedHttpClient as panoramaSiteHttpClient, WidgetOperationTypes as PanoramaWidgetOperationTypes } from '@openedx/frontend-base';


const customApp: App = {
  appId: 'custom',
};
addSlot(customApp, { op: PanoramaWidgetOperationTypes.APPEND, slotId: 'org.openedx.frontend.slot.header.secondaryLinks.v1', id: 'panorama_secondaryLinks', component: PanoramaSiteLink });
addSlot(customApp, { op: PanoramaWidgetOperationTypes.APPEND, slotId: 'org.openedx.frontend.slot.header.mobileMenuLinks.v1', id: 'panorama_mobileMenuLinks', component: PanoramaSiteLink });
function PanoramaSiteLink() {
  const user = panoramaSiteUseUser();
  const config = panoramaSiteUseConfig();
  const href = config.commonAppConfig?.PANORAMA_URL as string | undefined;
  const lms = config.lmsBaseUrl;
  const [access, setAccess] = panoramaSiteUseState<{ user: typeof user; allowed: boolean } | null>(null);
  panoramaSiteUseEffect(() => {
    let active = true;
    setAccess(null);
    if (user && href && lms) {
      panoramaSiteHttpClient().get(`${lms}/panorama/api/get-user-access`)
        .then(({ data }) => { if (active) setAccess({ user, allowed: data.body === true }); })
        .catch(() => { if (active) setAccess(null); });
    }
    return () => { active = false; };
  }, [user, href, lms]);
  return href && user && access?.user === user && access.allowed
    ? panoramaSiteCreateElement('a', { className: 'nav-link', href }, 'Panorama') : null;
}


export default customApp;